import { Client } from "../../clients/client";
import { PaginationForm, Pagination } from "@/common/mixins/pagination";
import { LineCreateForm } from "./forms/LineCreateForm";
import { LineUpdateForm } from "./forms/LineUpdateForm";
import { Line } from "./models/Line";
import { LineStopSyncSchedule } from "./models/LineStopSyncSchedule";
import { LineStopSyncCreateForm } from "./forms/LineStopSyncCreateForm";
import moment from "moment";

export class LineUseCase {
  constructor(private client: Client) {}

  async createShopLine(form: LineCreateForm) {
    return this.client.line.postLine({
      ...form,
      shopId: form.shop?.id!
    });
  }

  async updateShopLine(id: number, form: LineUpdateForm) {
    return this.client.line.patchLine(id, {
      ...form
    });
  }

  async getLine(form: PaginationForm): Promise<Pagination<Line>> {
    return this.client.line.getLine({
      page: form && form.page,
      limit: form && form.perPage
    });
  }

  async getLineById(id: number) {
    return this.client.line.getLineById(id);
  }

  async deleteLine(id: number) {
    return this.client.line.deleteLine(id);
  }

  async syncProductByShopId(id: number) {
    return this.client.line.postLineProductSyncByShopId(id);
  }

  async syncStockByShopId(id: number) {
    return this.client.line.postLineStockSyncByShopId(id);
  }

  async getLineStopSyncs(
    form: PaginationForm
  ): Promise<Pagination<LineStopSyncSchedule>> {
    return this.client.line.getLineScheduleTemporaryStopSyncStock({
      page: form && form.page,
      limit: form && form.perPage
    });
  }

  async createlineStopSync(form: LineStopSyncCreateForm) {
    return this.client.line.postLineScheduleTemporaryStopSyncStock({
      shopId: form.shop?.shopId!,
      fromDate: form.isStartImmediately
        ? undefined
        : moment(form.fromDate!).toISOString(),
      untilDate: moment(form.untilDate!).toISOString()
    });
  }
}
